<script setup>
  import { ref, onMounted } from 'vue';

  import { useSpotStore } from "@/stores/SpotStore";

  import useLegacyBridge from "@/composables/useLegacyBridge";

  const content = defineModel('content');

  const spotStore = useSpotStore();

  const { archiveData } = useLegacyBridge();

  const contentContainer = ref(null);
  
  function loadArchiveData() {
    const settings = {
      spotId: spotStore.spotId,
      displayYesterday: true,
      stationCapabilities: getStationCapabilities(spotStore.spot.stations),
    }       
    
    content.value = archiveData(contentContainer.value, settings);
  }

  function getStationCapabilities(stations) {
      var stationCapabilites = [];

      stations.forEach(function (station) {
          if (!station.capabilities) return;

          station.capabilities.forEach(function (capability) {
            if (!station.capabilities) return;

            if (stationCapabilites.indexOf(capability) === -1) {
                stationCapabilites.push(capability);
            }
          })
      })

      return stationCapabilites;
  }

  function getSettings() {
    if (content.value) {
      return content.value.getSettings();
    }

    return null;
  }

  onMounted(() => loadArchiveData());

  defineExpose({ getSettings })
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>